/// <amd-module name="Artifacts/Cargo/components/CargoFeatures" />
import { PackageAttribute } from "Artifacts/Package/components/package-details-common/PackageAttribute";
import * as React from "react";
import { Icon } from "VSSUI/Icon";

export interface ICargoFeaturesProps {
  features: { [feature: string]: string[] };
  title: string;
}

const CargoFeatures: React.FC<ICargoFeaturesProps> = ({ features, title }) => (
  <PackageAttribute title={title}>
    <div className="cargo-features">
      {features &&
        Object.keys(features).map((feature) => {
          if (features.default && feature !== "default") {
            return (
              <div>
                <Icon
                  className="feature-icon"
                  iconName={features.default.indexOf(feature) !== -1 ? "Completed" : "CircleRing"}
                />
                <div className="feature-text"> {feature} </div>
              </div>
            );
          }
        })}
    </div>
  </PackageAttribute>
);

export { CargoFeatures };
